import { FileJson } from "lucide-react";
import { createLucideIcon } from "./createLucideIcon";

export const InterfaceFileIcon = createLucideIcon(FileJson);
